<script setup lang="ts">
import { useI18n } from 'vue-i18n'

/**
 * Estimated relief, with "Up to" locked to the figure and the
 * estimate disclaimer underneath. HMRC calculates the final amount.
 */
withDefaults(
  defineProps<{
    showHint?: boolean
    /** Hide the figure from assistive tech when a nearby label already speaks it. */
    concealValue?: boolean
    /** result sits under the checker figure. guide is the one line in the paid guide. */
    hint?: 'result' | 'guide'
  }>(),
  {
    showHint: true,
    concealValue: false,
    hint: 'result',
  }
)

const { t } = useI18n()
</script>

<template>
  <div class="sa-claim-amount-with-hint">
    <span
      class="sa-claim-amount-with-hint__value"
      :aria-hidden="concealValue ? 'true' : undefined"
    >
      <span v-if="showHint" class="sa-claim-amount-with-hint__upto">
        <span class="sa-claim-amount-with-hint__qual">{{
          t('Dashboard.ClaimTaxBack.UpToLabel')
        }}</span>
        <slot />
      </span>
      <slot v-else />
    </span>
    <p
      v-if="showHint"
      class="sa-claim-amount-with-hint__note"
      :class="{ 'sa-claim-amount-with-hint__note--compact': hint === 'guide' }"
    >
      {{
        t(
          hint === 'guide'
            ? 'Dashboard.ClaimTaxBack.GuideClaimableHint'
            : 'Dashboard.ClaimTaxBack.ClaimableHint'
        )
      }}
    </p>
  </div>
</template>
